import { cn } from "@/lib/utils"

const STATUS_STYLES: Record<string, { label: string; dot: string }> = {
  published: { label: "Published", dot: "bg-success" },
  draft: { label: "Draft", dot: "bg-warning" },
  archived: { label: "Archived", dot: "bg-ink-4" },
  scheduled: { label: "Scheduled", dot: "bg-info" },
}

/** Neutral pill with a colored state dot (Linear status-badge): state is never color-only. */
export function StatusBadge({ status, className }: { status?: string | null; className?: string }) {
  const key = (status ?? "draft").toLowerCase()
  const style = STATUS_STYLES[key] ?? { label: key, dot: "bg-ink-4" }

  return (
    <span
      className={cn(
        "inline-flex h-5 shrink-0 items-center gap-1.5 rounded-full border bg-secondary px-2 text-xs font-medium capitalize text-ink-2",
        className,
      )}
    >
      <span className={cn("size-1.5 rounded-full", style.dot)} aria-hidden />
      {style.label}
    </span>
  )
}
